import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserActivityService } from './user-activity.service';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class TimeoutService {

  constructor(
    private activity: UserActivityService,
    private router: Router,
    private auth: AuthService
  ) {}

  startWatching() {
    this.activity.timeout$.subscribe(() => {
      alert('Session expired due to inactivity.');
      this.auth.logout();
    });
  }

  // logout() {
  //   localStorage.clear(); // remove token
  //   this.router.navigate(['/login']);
  // }
}
